import { styled } from "@mui/system";

export const NotFoundPanelContainer = styled("div")(({ theme }) => ({
    backgroundImage: "url(./images/notfound_background.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",

    [theme.breakpoints.down('lg')]: {
        backgroundImage: "url(./images/notfound_background.png)",
    },

    [theme.breakpoints.down('md')]: {
        backgroundImage: "url(./images/notfound_background.png)",
    },
}))

export const NotFoundInnerContainer = styled('div')(({ theme }) => ({
    width: '90%',
    margin: '0 auto',
    padding: '22vh 0px',
    height: 'calc(100vh - 80px)',

    [theme.breakpoints.down('md')]: {
        height: 'calc(100vh - 190px)',
        width: '95%',
        padding: '150px 20px 200px 20px',
    },
}))
